import { createFileRoute } from '@tanstack/react-router'
import { CRT_ROUTES, toStaticData } from '../crt-route-config'

export const Route = createFileRoute('/_auth/_modules/crt/azure-imports')({
  staticData: toStaticData(CRT_ROUTES['/crt/azure-imports']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
